export enum EndpointsCredentials {
  LoginCredentials = "/user/login",
  LoginCredentialsEmail = "/user/login/email",
}
